import { fetcher } from '@commenda/utils';

export async function unassignAgentFirmUser({
  serviceRequestId,
  userId,
}: {
  serviceRequestId: string;
  userId: string;
}) {
  const res = await fetcher(
    'service-request/unassign',
    {
      method: 'POST',
      body: { serviceRequestId, userId },
    },
    undefined
  );

  return res;
}
